import { UserDocument } from '@shared/types';

/**
 * Returns the attorney's `defaultHourlyRate` (parsed to a number) so the
 * matter form can pre-populate a new hourly matter's
 * `responsibleAttyHourlyRate` from the responsible attorney's default.
 *
 * Returns `undefined` whenever we can't produce a usable rate — missing
 * inputs, an unknown `userId`, an unset field, or a value that doesn't parse
 * to a positive number. Treating `0` and `NaN` the same collapses
 * "unset / invalid / explicitly-zero" into one "no default" signal, so
 * callers can just test for `undefined`.
 */
export const getAttorneyDefaultHourlyRate = (
  users: UserDocument[] | undefined,
  userId: string | undefined,
): number | undefined => {
  if (!userId || !users) {
    return undefined;
  }
  const user = users.find((candidate) => candidate.id === userId);
  const rate = Number(user?.defaultHourlyRate);
  if (!Number.isFinite(rate) || rate <= 0) {
    return undefined;
  }
  return rate;
};
